import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { LocatorState } from './types'
import { RootState } from '@/store/types'

export const state: LocatorState = {
  search: 'all',
}

const namespaced = true

export const locator: Module<LocatorState, RootState> = {
  namespaced,
  mutations,
  actions,
  getters,
  state,
}
